import { BlockChiliPiperSchedulerProps } from '@/types/blocks';
import { UtmHelper } from '@/utils/utm';
import { useSearchParams } from 'next/navigation';

interface ChiliPiperSchedulerProps {
  id: string;
  url: string | null;
}

function ChiliPiperSchedulerComponent(props: ChiliPiperSchedulerProps) {
  const { url, ...rest } = props;

  if (!url) return null;

  return (
    <div {...rest} className='w-full'>
      <div className='flex justify-center'>
        <iframe src={url} className='h-[860px] w-full md:h-[760px]'></iframe>
      </div>
    </div>
  );
}

function isChiliPiperUrl(url: string): boolean {
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === 'https:' && hostname.endsWith('.chilipiper.com');
  } catch {
    return false;
  }
}

function withUtmParams(url: string): string {
  return UtmHelper.appendToUrl(url, UtmHelper.getUtmParamsWithFallback());
}

export function ChiliPiperSchedulerFromUrlQuery(
  props: BlockChiliPiperSchedulerProps
) {
  const { url, ...rest } = props;
  const params = useSearchParams();
  const fromQuery = params.get('chilipiper');
  const cmsUrl = url && isChiliPiperUrl(url) ? withUtmParams(url) : null;

  return <ChiliPiperSchedulerComponent {...rest} url={cmsUrl ?? fromQuery} />;
}

export function ChiliPiperSchedulerFromProps(props: ChiliPiperSchedulerProps) {
  return <ChiliPiperSchedulerComponent {...props} />;
}
